<div class="flex flex-col justify-between">
  <table class="no-space w-full" cellspacing="0" cellpadding="4">
    @if (timeSheet.currentEmployeeCrew.length > 0) {
      <tr class="h-[50px]">
        <th class="min-w-[300px]">
          <div class="items-center justify-center">
            <a mat-raised-button routerLink="/crew/labor">
              <mat-icon>person</mat-icon>
              Add Employees
            </a>
          </div>
        </th>
        <th><button mat-raised-button aria-label="Bulk Add Standard Time" (click)="bulkEntry('st')">ST</button></th>
        <th><button mat-raised-button aria-label="Bulk Add Overtime" (click)="bulkEntry('ot')">OT</button></th>
        <th><button mat-raised-button aria-label="Bulk Add Double Time" (click)="bulkEntry('dt')">DT</button></th>
        <th>Daily Total</th>
        <th>Weekly Total</th>
      </tr>
    } @else {
      <tr class="h-[500px]">
        <th>
          <a mat-raised-button routerLink="/crew/labor">Start Here</a>
        </th>
      </tr>
    }

    @for (row of timeSheet.currentEmployeeCrew; track row) {
      <tr>
        <td>
          <read-only-text
            [val]="row.display"
            [shouldShowDelete]="true"
            (deleteClicked)="row.deleteSelf(timeSheet.currentEmployeeCrew)"
          />
        </td>
        <td>
          <numeric-input-field formClass="order-first" [max]="24" [control]="row.rows.st.hours" />
        </td>
        <td>
          <numeric-input-field [max]="24" [control]="row.rows.ot.hours" />
        </td>
        <td>
          <numeric-input-field formClass="order-last" [max]="24" [control]="row.rows.dt.hours" />
        </td>
        <td>
          <read-only-field [val]="row.workDateTotal | number" />
        </td>
        <td>
          <read-only-field [val]="row.weDateTotal | number" />
        </td>
      </tr>
    }
  </table>
</div>
